<template>
    <IllustratedMessage v-if="!results.length">
        {{ lang('manual::manual.no_results') }}
    </IllustratedMessage>
    <ul v-else class="manual-search-results">
        <li v-for="result in results" :key="result.uid">
            <button type="button" class="manual-search-results__item" @click="$emit('select', result.uid)">
                <span class="manual-search-results__title">{{ result.title }}</span>
                <span v-if="result.snippet" class="manual-search-results__snippet">{{ result.snippet }}</span>
            </button>
        </li>
    </ul>
</template>

<script setup lang="ts">
import { lang } from '@/lang/composable';
import type { ManualSearchResult } from '@src/Manual/Pages/composables/useManualDrawer';

defineProps<{ results: ManualSearchResult[] }>();
defineEmits<{ select: [uid: string] }>();
</script>

<style scoped>
.manual-search-results {
    list-style: none;
    margin: 0;
    padding: 0;
}
.manual-search-results__item {
    display: block;
    width: 100%;
    text-align: left;
    padding: 0.375rem 0;
    border-bottom: 1px solid rgba(128, 128, 128, 0.15);
}
.manual-search-results__title {
    font-weight: 500;
}
.manual-search-results__snippet {
    display: block;
    font-size: 0.75rem;
    opacity: 0.6;
}
</style>
